import { render, staticRenderFns } from "./loadHistory.vue?vue&type=template&id=ec6f0bbc"
import script from "./loadHistory.vue?vue&type=script&lang=js"
export * from "./loadHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports